// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperSideNav_root__2QIXy","tabs":"LayoutWrapperSideNav_tabs__3Oqu9","tab":"LayoutWrapperSideNav_tab__Oh_Ho"};